export const flattenEdges = <T>(edges: Array<{ node?: T | null }> | undefined): T[] => (edges || []).flatMap((edge) => (edge.node ? [edge.node] : []));
